import { ThreeDeeViewer } from '../ThreeDeeViewer';
import { useViewerRouteParams } from '@/hooks';

export const ViewerRouter = () => {
  const { viewerType } = useViewerRouteParams();

  switch (viewerType) {
    case '3D':
      return <ThreeDeeViewer />;
    default:
      return <></>;
  }
};
